import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { VSnackbar } from 'vuetify/components'

export type SnackbarMessage = string | Pick<VSnackbar['$props'], 'color' | 'text' | 'timeout'>

export const useMessagesStore = defineStore('messages', () => {
  const queue = ref<SnackbarMessage[]>([])
  function addMessage(message: SnackbarMessage) {
    queue.value.push(message)
  }

  return { queue, addMessage }
})
